function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 34,
  fill: "white",
  stroke: "#6F62FF",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.25 35.5C24.1487 29.5335 28.9551 25.8572 35.125 25.8572C42.5681 25.8572 48.0977 31.1758 52 35.6055C51.8767 35.7278 51.7516 35.8522 51.6247 35.9784C47.8278 39.7536 42.4075 45.1429 35.125 45.1429C27.8346 45.1429 23.6061 40.8886 18.739 35.9918C18.5768 35.8285 18.4138 35.6646 18.25 35.5ZM28.375 35.5C28.375 39.2894 31.4035 42.3781 35.125 42.3781C38.8465 42.3781 41.875 39.2969 41.875 35.5C41.875 31.7107 38.8465 28.622 35.125 28.622C31.4035 28.622 28.375 31.7032 28.375 35.5ZM35.6972 31.53C35.3431 31.9518 35.1247 32.4943 35.1247 33.0894C35.1247 34.4228 36.202 35.5001 37.5429 35.5001C38.1079 35.5001 38.6202 35.3042 39.0345 34.9803C39.0496 35.1536 39.0647 35.3268 39.0647 35.5001C39.0647 37.715 37.2943 39.5155 35.1247 39.5155C32.955 39.5155 31.1847 37.715 31.1847 35.5001C31.1847 33.2853 32.955 31.4848 35.1247 31.4848C35.3205 31.4848 35.5089 31.4998 35.6972 31.53Z",
  fill: "#6F62FF"
});

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.4f8efb80.svg";
export { ForwardRef as ReactComponent };